export default "__VITE_ASSET__e4b8ef53__"